export default __webpack_public_path__ + "images/HA.72ad473.png";